module.exports = __webpack_public_path__ + "images/icon-completed-fed736b22aa1e288eee46aca7a4ce80b.png";